var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import classNames from 'clsx';
import * as React from 'react';
import Icon from '../icon';
import Input from '../input';
import Loader from '../loader';
import { Styled } from './style';
export var ValidationStatus;
(function (ValidationStatus) {
    ValidationStatus[ValidationStatus["Success"] = 0] = "Success";
    ValidationStatus[ValidationStatus["Warning"] = 1] = "Warning";
    ValidationStatus[ValidationStatus["Error"] = 2] = "Error";
})(ValidationStatus || (ValidationStatus = {}));
var StatusInput = /** @class */ (function (_super) {
    __extends(StatusInput, _super);
    function StatusInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.inputRef = React.createRef();
        return _this;
    }
    StatusInput.prototype.handleKeyPress = function (e) {
        if (e.key === 'Enter') {
            if (this.props.onBlur) {
                this.props.onBlur(e);
            }
        }
    };
    StatusInput.prototype.render = function () {
        var _a = this.props, validationStatus = _a.validationStatus, isValidateComplete = _a.isValidateComplete, isValidating = _a.isValidating, placeholder = _a.placeholder, value = _a.value, onBlur = _a.onBlur, onChange = _a.onChange, spellCheck = _a.spellCheck, type = _a.type;
        return (React.createElement(Styled, { className: classNames(isValidating ? 'status-loading' : 'status-default', {
                'status-success': isValidateComplete && validationStatus === ValidationStatus.Success,
                'status-warning': isValidateComplete && validationStatus === ValidationStatus.Warning,
                'status-error': isValidateComplete && validationStatus === ValidationStatus.Error,
            }) },
            React.createElement(Input, { autoFocus: true, type: type ? type : 'text', autoCorrect: type === 'url' ? 'off' : 'on', ref: this.inputRef, placeholder: placeholder, value: value, onBlur: onBlur, onChange: onChange, onKeyPress: this.handleKeyPress.bind(this), spellCheck: spellCheck }),
            React.createElement("div", { className: "symbol-container" }, isValidateComplete ? (validationStatus === ValidationStatus.Success ? (React.createElement(Icon, { name: "checked-circle" })) : (React.createElement(Icon, { name: "warning" }))) : isValidating ? (React.createElement(Loader, { size: "tiny", inline: true, active: true })) : null)));
    };
    return StatusInput;
}(React.Component));
export { StatusInput };
export default StatusInput;
//# sourceMappingURL=index.js.map